
    var countryIsUSA = false;


      function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
      }

        function redirectUSAUsers() {
            const allowedProductUrl = "/en/products/socialplate_usa";
            const currentUrl = window.location.pathname;
        
            if (currentUrl !== allowedProductUrl) {
                alert("At the moment, we only sell the Socialplate in the USA. The other products you might see but can't purchase yet will be available soon! You will get redirected automatically.");
                window.location.href = allowedProductUrl;
            }
        }



      let icartcountriesShow = async () => {
        let userCountry = getCookie('_UserCountry');
        if(userCountry === null || userCountry === undefined){
            let response = await fetch('/browsing_context_suggestions.json');
            response = await response.json();
            if (Object.keys(response.detected_values.country).length !== 0) {
               let systemDate = new Date();
               systemDate.setTime(systemDate.getTime() + (1440 * 60 * 1000));
               let expires = 'expires=' + systemDate.toUTCString();
               userCountry = response.detected_values.country.handle;
               document.cookie = '_UserCountry' + '=' + response.detected_values.country.handle + ';' + expires + ';path=/; SameSite=None; Secure';
             }
        }

           //userCountry = "USA";
           console.log("userCountry: "+userCountry);
       
         if (userCountry == "US") {
           countryIsUSA = true;
            redirectUSAUsers();
         }
      }
      icartcountriesShow();
